import React from 'react';
import iconerror from '../images/icon-error.png';
import { useTranslation } from "react-i18next";

export function PaginaNoExiste() {
    const { t, i18n } = useTranslation();
    return (
        <div className="flex-column">
            <div style={{ textAlign: 'center' }} >
                <img src={iconerror} alt="Error" width="150" height="150" />
                <p style={{ fontSize: 'x-large' }}>{t('paginaNoExiste.textoNoExiste')}</p>
            </div>

        </div>
    )
}